export enum InvoiceStatusTypes{
    New = 1,
    Paid = 2,
    PartiallyPaid = 3,
    Deleted = 4,
    Sent = 5,
    Void = 6
}